<template>
  <div class="home">
    <img alt="Vue logo" src="../assets/logo.png" />
    <HelloWorld msg="Welcome to Your Vue.js App" />
    <datav></datav>
  </div>
</template>

<script>
// @ is an alias to /src

import datav from '../components/datav/index.vue';

export default {
  name: 'app',
  components: {
    datav
  },
  data() {
    return {};
  }
};
</script>
